import { FlatDrawer } from '..';
import type { ReactiveVars } from '../../../..';

export default function createOpenDrawer(drawersVar: ReactiveVars['drawersVar']) {
  return <T extends FlatDrawer>(drawer: T): void => {
    drawersVar([drawer]);
  };
}
